 import React from "react";

const Footer = (props) => {
  let d = new Date();
  return (
    <div className={`footer ${props.changeFooter}`}>
      <div className="copyright">
        <p>
          Copyright © Recode Technologies &amp; Maintained by{" "}
          <a href="http://dexignlab.com/" target="_blank" rel="noreferrer">
            Recode Technologies
          </a>{" "}
          {d.getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default Footer;
